<apex-client-addon-cart-product-card
  class="df c"
  *ngFor="let product of products"
  [product]="product"
  [editable]="editable"
  [addonManager]="addonManager"
  (remove)="remove.emit($event)"
  (update)="update.emit($event)">
</apex-client-addon-cart-product-card>
